import React, { PropsWithChildren } from "react";
//#region types
import { SimpleMessageProps } from "models/propTypes/messagePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { CSSHelper } from "utils/helpers";

const SimpleMessage: React.FC<PropsWithChildren<SimpleMessageProps>> = (props) => {
  return (
    <Grid
      container
      className={clsx(cssExports.simpleMessage, CSSHelper.getClassByDisplayType(props.displayType), props.className)}
      spacing={1}
    >
      {props.icon && (
        <Grid item className={cssExports.simpleMessageIcon}>
          <Icon icon={props.icon} />
        </Grid>
      )}
      <Grid item xs>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default SimpleMessage;
